// Port of api/fuel/app/classes/insights/games/overview.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import DB from 'offline/db'

function monthStartOffset(monthOffset) {
	var d = new Date()
	d.setUTCDate(1)
	d.setUTCHours(0, 0, 0, 0)
	d.setUTCMonth(d.getUTCMonth() + monthOffset)
	return Math.floor(d.getTime() / 1000)
}

export default Segment.extend({
	name: 'overview',
	priority: 8,
	types: [Constants.TYPE_USER],
	requires: ['init', 'universe'],
	run: function(type, owner) {
		var firstTouch = this._data.first_touch || {}
		var snapshot = this._data.snapshot
		var orbits = this._data.orbits || { fresh: 0, active: 0, stale: 0 }

		var snapshotTotal = snapshot ? parseInt(snapshot.insight_total || 0, 10) : Object.keys(firstTouch).length
		var snapshotOwned = snapshot ? parseInt(snapshot.insight_owned || 0, 10) : 0
		var snapshotPrevowned = snapshot ? parseInt(snapshot.insight_prevowned || 0, 10) : 0
		var snapshotPlayed = snapshot ? parseInt(snapshot.insight_played || 0, 10) : 0
		var snapshotRated = snapshot ? parseInt(snapshot.insight_rated || 0, 10) : 0
		var snapshotWishlist = snapshot ? parseInt(snapshot.insight_wishlist || 0, 10) : 0

		var overview = {
			totalTouched: snapshotTotal,
			owned: snapshotOwned,
			prevowned: snapshotPrevowned,
			played: snapshotPlayed,
			rated: snapshotRated,
			wishlist: snapshotWishlist,
			fresh: parseInt(orbits.fresh || 0, 10),
			stale: parseInt(orbits.stale || 0, 10),
			newThisYear: 0,
			peakYear: { year: 0, count: 0 }
		}

		var yearStart = new Date()
		yearStart.setUTCMonth(0, 1)
		yearStart.setUTCHours(0, 0, 0, 0)
		var yearStartTs = Math.floor(yearStart.getTime() / 1000)
		var byYear = {}

		var touchKeys = Object.keys(firstTouch)
		for (var i = 0; i < touchKeys.length; i++) {
			var ft = firstTouch[touchKeys[i]]
			if (ft.date >= yearStartTs) overview.newThisYear++
			var y = parseInt(Util.date('Y', ft.date), 10)
			if (!byYear[y]) byYear[y] = 0
			byYear[y]++
		}

		var byYearKeys = Object.keys(byYear)
		if (byYearKeys.length) {
			var peakYear = 0
			var peakCount = 0
			for (var yk = 0; yk < byYearKeys.length; yk++) {
				var year = parseInt(byYearKeys[yk], 10)
				if (byYear[year] > peakCount) {
					peakCount = byYear[year]
					peakYear = year
				}
			}
			overview.peakYear = { year: peakYear, count: peakCount }
		}

		overview.unratedPercent = overview.totalTouched > 0 ? Math.round(((overview.totalTouched - overview.rated) / overview.totalTouched) * 100) : 0

		var ratingValues = this._data.rating_data ? this._data.rating_data.values : {}
		var ratingKeys = Object.keys(ratingValues)
		overview.avgRating = ratingKeys.length ? Math.round((ratingKeys.reduce(function(sum, key) { return sum + parseFloat(ratingValues[key]) }, 0) / ratingKeys.length) * 10) / 10 : 0

		var playCounts = this._data.play_data ? this._data.play_data.counts : {}
		var playKeys = Object.keys(playCounts)
		overview.avgPlays = playKeys.length ? Math.round((playKeys.reduce(function(sum, key) { return sum + parseInt(playCounts[key], 10) }, 0) / playKeys.length) * 10) / 10 : 0

		overview.unplayedPercent = overview.totalTouched > 0 ? Math.round(((overview.totalTouched - overview.played) / overview.totalTouched) * 100) : 0

		if (touchKeys.length) {
			var dates = touchKeys.map(function(key) { return parseInt(firstTouch[key].date, 10) })
			var earliest = Math.min.apply(Math, dates)
			var monthsElapsed = Math.max(1, Math.round((Util.time() - earliest) / (30.44 * 86400)))
			overview.avgMonthly = Math.round((overview.totalTouched / monthsElapsed) * 10) / 10
		} else {
			overview.avgMonthly = 0
		}

		var currentTotal = overview.totalTouched
		var trend = { one: null, six: null, twelve: null }
		var trendDates = {
			one: monthStartOffset(-1),
			six: monthStartOffset(-6),
			twelve: monthStartOffset(-12)
		}

		var pastSnapshots = DB.query(
			'SELECT insight_date, insight_total FROM insight_user_games WHERE user_id = ' + owner.get_id() +
			' AND insight_date IN (' + trendDates.one + ', ' + trendDates.six + ', ' + trendDates.twelve + ')'
		)
		var pastMap = {}
		for (var ps = 0; ps < pastSnapshots.length; ps++) pastMap[parseInt(pastSnapshots[ps].insight_date, 10)] = parseInt(pastSnapshots[ps].insight_total, 10)
		var trendKeys = Object.keys(trendDates)
		for (var tk = 0; tk < trendKeys.length; tk++) {
			var key = trendKeys[tk]
			if (pastMap[trendDates[key]] !== undefined) trend[key] = currentTotal - pastMap[trendDates[key]]
		}
		overview.trend = trend

		return { overview: overview }
	}
})
